export default {
	data() {
		return {
			filterStatus: { field: "status", index: null }
		};
	},
	watch: {
		"filterStatus.index": {
			handler(newVal) {
				let val = this.filterStatus;
				if (val.index != null && val.index !== "") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.index });
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true
		}
	}
};
